import HeroSection from '@/components/sections/HeroSection'
import FeaturesSection from '@/components/sections/FeaturesSection'
import CTASection from '@/components/sections/CTASection'
import { homeHero, homeFeatures, homeCTA } from '@content/pages/home'

export default function HomePage() {
  return (
    <>
      <HeroSection {...homeHero} />
      <FeaturesSection features={homeFeatures} />
      <CTASection {...homeCTA} />
    </>
  )
}
